// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1T0VS","header":"ClearentDisclaimer_header__1_iPo","inner":"ClearentDisclaimer_inner__31W85"};